// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"80":"ce971157","140":"f13606bd"}[chunkId] + ".chunk.css");